module.exports = __webpack_public_path__ + "img/icon-send-comment.78998c8e.svg";